import { Turbo } from "@hotwired/turbo-rails"

/**
 * Makes a reveal request to the server
 * Extracted from multi_domain_search.tsx for reuse
 */
export const revealRequest = async (url: string, method: string, body: any) => {
  const response = await fetch(url, {
    method,
    body: method === "POST" ? JSON.stringify(body) : undefined,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
        ?.content,
    },
  })

  if (response.headers.get("Content-Type")?.includes("turbo-stream")) {
    Turbo.renderStreamMessage(await response.text())
    return "lack_of_credits"
  } else {
    return "success"
  }
}

/**
 * Creates a batch processor for WebSocket results
 * Extracted from multi_domain_search.tsx for reuse
 */
export const createProcessResult = (
  setResults: React.Dispatch<React.SetStateAction<any[]>>,
  setRevealedIds: React.Dispatch<React.SetStateAction<number[]>>,
  setRevealingIds: React.Dispatch<React.SetStateAction<number[]>>,
  setFirstRevealAt?: React.Dispatch<React.SetStateAction<Date | null>>
) => {
  return (results: any[]) => {
    setResults((prev) => {
      const newRevealedIds: number[] = []
      const newResults = prev.map((result) => {
        const newResultData = results.find((r) => r.id === result.id)

        if (newResultData) {
          newRevealedIds.push(newResultData.id)
          return newResultData
        } else {
          return result
        }
      })

      setRevealedIds((prev) => [...new Set([...prev, ...newRevealedIds])])

      if (setFirstRevealAt) {
        setFirstRevealAt((prev) => prev === null ? new Date() : prev)
      }

      setRevealingIds((prev) => {
        return prev.filter((id) => !newRevealedIds.includes(id))
      })

      return newResults
    })
  }
}
